// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { AnalysisTypeIdEnum } from 'config/enums'
import goToEarthStationResults from './goToEarthStationResults'
import goToAfsGrid from './goToAfsGrid'

// This thunk takes an analysisStatus DTO and determines
// if the user is trying to look at Earth Station results
// or the AFS Grid.

const handleSpecificAnalysisStatusSelection = analysisStatus => async dispatch => (
  analysisStatus.analysisTypeId === AnalysisTypeIdEnum.EARTH_STATION
    ? dispatch(goToEarthStationResults(analysisStatus))
    : dispatch(goToAfsGrid(analysisStatus))
)

export default handleSpecificAnalysisStatusSelection
